export default __webpack_public_path__ + "static/media/loppumusiikki_tappio.23a47750.mp3";